import $ from 'jquery'

import cache from './cache'
import settings from './settings'

const closeCart = () => {
  cache.$header.removeClass('is-open')
  cache.$cartSwitch.text('Cart')
  cache.$cart.removeClass('is-open')
}

const scrollTo = ($el, $to, el) => {
  let $thisTo = $to

  if (window.matchMedia('( min-width: 1200px ) and ( min-height: 1050px )').matches) {
    if (el !== '#stockists' && el !== '#spirits-trade') {
      $thisTo = $el.offset().top
    }
  } else if (window.matchMedia('( min-width: 1200px ) and ( min-height: 850px )').matches) {
    if (el !== '#stockists' && el !== '#spirits-trade') {
      $thisTo = $el.find('.o-content').offset().top
    }
  }

  if ($el.length) {
    if (cache.$header.hasClass('is-open') || cache.$cart.hasClass('is-open')) {
      setTimeout(() => {
        cache.$htmlBody.animate(
          {
            scrollTop: $thisTo,
          },
          settings.SPEED,
          settings.EASING,
        )
      }, settings.SPEED)
    } else {
      cache.$htmlBody.animate(
        {
          scrollTop: $thisTo,
        },
        settings.SPEED,
        settings.EASING,
      )
    }
  }
  closeCart()
}

const enable = () => {
  cache.$jump.on('click', (e) => {
    const $this = $(e.target)
    const $href = $this.attr('href')
    const $el = $($href)
    const $to = ($el.offset().top - cache.$header.outerHeight()) * 2
    const el = `#${$href.split('#')[1]}`

    e.preventDefault()
    scrollTo($el, $to, el)
  })
}

export default {
  enable,
  scrollTo,
}
